import { NotificationManager } from "react-notifications";

export function copyToClipboard(text) {
	navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
		if (result.state === "granted" || result.state === "prompt") {
			navigator.clipboard.writeText(text);
		} else {
            NotificationManager.error("Clipboard write access denied. Check your Site Setting Permissions for Clipboard.");
        }
	});
};
